export const contactsData = {
    email: 'abd.contactme@gmail.com',
    phone: '+90 534 075 1964',
    address: 'Istanbul / Turkey ',

    sheetAPI: ''
}